<template>
    <div class="empty">
        <div class="empty__message">
            <i class="uk-icon-check"></i>
            <span>Сообщения эмитента не найдены.</span>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="sass" scoped>
.empty
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    &__message
        display: flex
        flex-direction: column
        align-items: center
        gap: 10px
        i
            color: #bcf2db
            font-size: 30px
        span
            color: #777
            font-size: 16px
</style>